/**
 *
 * SortIndicator
 *
 */

import React, { memo, FunctionComponent } from 'react';
import { Sort } from '../../domain';
import { StyledSortIndicator } from './styledComponents';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import infoIcon from '../../assets/icons/info.svg';


interface IProps {
  field: string;
  name: string;
  changeSort: (field: string) => void;
  sort?: Sort;
  disabledFields: string[];
  tooltip?: string;
  className?: string;
}

const SortIndicator: FunctionComponent<IProps> = ({
  field,
  sort,
  name,
  changeSort,
  disabledFields,
  tooltip,
  className,
}) => {
  if (disabledFields.includes(field)) {
    return null;
  }

  const renderTooltipHelper = () => (
    <>
      {tooltip && (
        <OverlayTrigger overlay={<Tooltip>{tooltip}</Tooltip>}>
          <img
            style={{ marginLeft: 5 }}
            width="15px"
            src={infoIcon}
            alt=""
            onClick={(e) => e.stopPropagation()}
          />
        </OverlayTrigger>
      )}
    </>
  );

  if (!field) {
    return (
      <>
        <span className="text-nowrap">{name}</span>
        {renderTooltipHelper()}
      </>
    );
  }

  return (
    <StyledSortIndicator
      active={field === sort?.field}
      onClick={() => changeSort(field)}
      className={className}
    >
      <span className='text-nowrap'>{name}</span>
      {field === sort?.field &&
        (sort?.order === 'asc' ? <span>&#x25BC;</span> : <span>&#x25B2;</span>)}
      {renderTooltipHelper()}
    </StyledSortIndicator>
  );
};

export default memo(SortIndicator);
